import React from "react";

const Operators: React.FC = () => {
  return (
    <div>
      <h1>Operatörler</h1>
      <p>Operatör yönetimi sayfası burada geliştirilecek.</p>
    </div>
  );
};

export default Operators;
